import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validator, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr'
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-onboarding-images',
  templateUrl: './onboarding-images.component.html',
  styleUrls: ['./onboarding-images.component.scss']
})
export class OnboardingImagesComponent implements OnInit {

  imageForm: any = FormGroup;
  id: any
  image1: any;
  image2: any;
  image3: any;
  image4: any;
  imageFile1: any;
  imageFile2: any;
  imageFile3: any;
  imageFile4: any;
  selectedLanguage: any = [
    { lable: "English", value: "en" },
    { lable: "Danish", value: "da" }
  ];
  constructor(
    private service: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    public route: Router,
    public router: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.imageForm = new FormGroup({
      image1: new FormControl('', Validators.required),
      image2: new FormControl('', Validators.required),
      image3: new FormControl('', Validators.required),
      image4: new FormControl('', Validators.required),
      language: new FormControl('en', Validators.required),
    })
    this.getUploadImages()
  }

  onSubmit() {
    if (this.id) {

      this.spinner.show();
      // console.log("store form data.........", this.storeForm.value)
      const formData = new FormData();

      if (this.imageFile1) {
        formData.append('image1', this.imageFile1);
      }
      if (this.imageFile2) {
        formData.append('image2', this.imageFile2);
      }
      if (this.imageFile3) {
        formData.append('image3', this.imageFile3);
      }
      if (this.imageFile4) {
        formData.append('image4', this.imageFile4);
      }
      formData.append('language', this.imageForm.value.language);
      this.service.putRequest(`${ApiUrl.updateuploadimage}${this.id}`, formData).subscribe(
        (res: any) => {
          this.toastr.success(res.response.message);
          // this.route.navigate(['/onboardingimages']);    
          this.spinner.hide();
          // this.getUploadImages()
          this.imageFile1 = null
          this.imageFile2 = null
          this.imageFile3 = null
          this.imageFile4 = null

        }, (err) => {
          // this.toastr.error(err.error?.response?.message)
          this.spinner.hide();
        }
      );
    } else {
      this.spinner.show();
      var formData = new FormData();
      formData.append('image1', this.imageFile1);
      formData.append('image2', this.imageFile2);
      formData.append('image3', this.imageFile3);
      formData.append('image4', this.imageFile4);
      formData.append('language', this.imageForm.value.language);

      this.service.postRequest(ApiUrl.uploadimage, formData).subscribe((res: any) => {
        // console.log(res, "res")
        this.toastr.success(res.response.message);
        // this.route.navigate(['/onboardingimages']);
        this.spinner.hide();

      }
        , (err) => {
          // this.toastr.error(err.error?.response?.message)
          this.spinner.hide();
        });
    }
    // console.log(this.imageForm)
  }

  updateImage(event: any, name: any) {
    let files = event.target.files[0];
    // console.log(files, "file")
    const reader = new FileReader();
    reader.onload = (e: any) => {
      if (name == 'Image1') {
        this.image1 = e.target.result;
        this.imageFile1 = files;
      } else if (name == 'Image2') {
        this.image2 = e.target.result;
        this.imageFile2 = files;
      }
      else if (name == 'Image3') {
        this.image3 = e.target.result;
        this.imageFile3 = files;
      }
      else {
        this.image4 = e.target.result;
        this.imageFile4 = files;
      }
    };
    reader.readAsDataURL(files);
  }
                                 
  removeImage(name: any) {
    if (name == 'Image1') {
      this.image1 = '';
      this.imageForm.patchValue({
        image1: '',
      });
    } else if (name == 'Image2') {
      this.image2 = '';
      this.imageForm.patchValue({
        image2: '',
      });
    }
    else if (name == 'Image3') {
      this.image3 = '';
      this.imageForm.patchValue({
        image3: '',
      });
    }
    else {
      this.image4 = '';
      this.imageForm.patchValue({
        image4: '',
      });
    }
  }

  getUploadImages() {
    this.spinner.show()
    this.image1 = ""
    this.image2 = ""
    this.image3 = ""
    this.image4 = ""
    this.service.getRequest(`${ApiUrl.getimages}/${this.imageForm.value.language}`).subscribe((res: any) => {
      this.id = res.response.data?._id              
      this.image1 = `${environment.imageUrl}${res.response.data.imageUrl1}`
      this.image2 = `${environment.imageUrl}${res.response.data.imageUrl2}`
      this.image3 = `${environment.imageUrl}${res.response.data.imageUrl3}`
      this.image4 = `${environment.imageUrl}${res.response.data.imageUrl4}`
      this.imageForm.patchValue({
        language: res.response.data.language
      })
      this.spinner.hide()

    }, (err) => {
      this.toastr.error(err.error.response.message)
      this.spinner.hide()
    })   
  }

  onBack() {
    this.route.navigate(['/dashboard/onboardingimages'])
  }

}
